<template>
    <section class="section faq-two pb-0">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="section__header--secondary wow fadeInUp" data-wow-duration="600ms"
                        data-wow-delay="300ms">
                        <div class="row align-items-center items-gap">
                            <div class="col-12 col-xl-7">
                                <h2 class="h2">frequently ask questions</h2>
                            </div>
                            <div class="col-12 col-xl-5">
                                <div class="faq-two__switch">
                                    <p class="abc cd">General Questions</p>
                                    <div class="switcher">
                                        <input type="checkbox" id="switch">
                                        <label for="switch">Toggle</label>
                                    </div>
                                    <p class="atc">Members & Contributors</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="faq-tab-content" id="faqOne">
                        <div class="accordion" id="accordion">
                            <div class="row items-gap">
                                <div class="col-12 col-lg-6">
                                    <div class="faq__two-left">
                                        <div class="accordion-item wow fadeInUp" data-wow-duration="600ms"
                                            data-wow-delay="600ms">
                                            <h5 class="accordion-header" id="headingOne">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseOne" aria-expanded="true"
                                                    aria-controls="collapseOne">
                                                    What is ChatGPT?
                                                </button>
                                            </h5>
                                            <div id="collapseOne" class="accordion-collapse collapse show"
                                                aria-labelledby="headingOne" data-bs-parent="#accordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item wow fadeInUp" data-wow-duration="600ms"
                                            data-wow-delay="900ms">
                                            <h5 class="accordion-header" id="headingTwo">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                    aria-expanded="false" aria-controls="collapseTwo">
                                                    How is Chatsonic different from ChatGPT by Open
                                                    AI?
                                                </button>
                                            </h5>
                                            <div id="collapseTwo" class="accordion-collapse collapse"
                                                aria-labelledby="headingTwo" data-bs-parent="#accordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item content__space wow fadeInUp"
                                            data-wow-duration="600ms" data-wow-delay="1200ms">
                                            <h5 class="accordion-header" id="headingThree">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                    aria-expanded="false" aria-controls="collapseThree">
                                                    What format are the files in?
                                                </button>
                                            </h5>
                                            <div id="collapseThree" class="accordion-collapse collapse"
                                                aria-labelledby="headingThree" data-bs-parent="#accordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="faq__two-right">
                                        <div class="accordion-item content__space wow fadeInUp"
                                            data-wow-duration="600ms" data-wow-delay="1500ms">
                                            <h5 class="accordion-header" id="headingFour">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                    aria-expanded="false" aria-controls="collapseFour">
                                                    What is ChatGPT used for?
                                                </button>
                                            </h5>
                                            <div id="collapseFour" class="accordion-collapse collapse"
                                                aria-labelledby="headingFour" data-bs-parent="#accordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item content__space wow fadeInUp"
                                            data-wow-duration="600ms" data-wow-delay="1500ms">
                                            <h5 class="accordion-header" id="headingFive">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseFive"
                                                    aria-expanded="false" aria-controls="collapseFive">
                                                    How can I support this site?
                                                </button>
                                            </h5>
                                            <div id="collapseFive" class="accordion-collapse collapse"
                                                aria-labelledby="headingFive" data-bs-parent="#accordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item content__space wow fadeInUp"
                                            data-wow-duration="600ms" data-wow-delay="1500ms">
                                            <h5 class="accordion-header" id="headingSix">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseSix"
                                                    aria-expanded="false" aria-controls="collapseSix">
                                                    How do I add/change my profile picture?
                                                </button>
                                            </h5>
                                            <div id="collapseSix" class="accordion-collapse collapse"
                                                aria-labelledby="headingSix" data-bs-parent="#accordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="faq-tab-content" id="faqTwo">
                        <div class="accordion" id="memberaccordion">
                            <div class="row items-gap">
                                <div class="col-12 col-lg-6">
                                    <div class="faq__two-right">
                                        <div class="accordion-item content__space wow fadeInUp"
                                            data-wow-duration="600ms" data-wow-delay="1500ms">
                                            <h5 class="accordion-header" id="memberheadingFour">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#membercollapseFour"
                                                    aria-expanded="false" aria-controls="membercollapseFour">
                                                    What is ChatGPT used for?
                                                </button>
                                            </h5>
                                            <div id="membercollapseFour" class="accordion-collapse collapse"
                                                aria-labelledby="memberheadingFour" data-bs-parent="#memberaccordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item content__space wow fadeInUp"
                                            data-wow-duration="600ms" data-wow-delay="1500ms">
                                            <h5 class="accordion-header" id="memberheadingFive">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#membercollapseFive"
                                                    aria-expanded="false" aria-controls="membercollapseFive">
                                                    How can I support this site?
                                                </button>
                                            </h5>
                                            <div id="membercollapseFive" class="accordion-collapse collapse"
                                                aria-labelledby="memberheadingFive" data-bs-parent="#memberaccordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item content__space wow fadeInUp"
                                            data-wow-duration="600ms" data-wow-delay="1500ms">
                                            <h5 class="accordion-header" id="memberheadingSix">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#membercollapseSix"
                                                    aria-expanded="false" aria-controls="membercollapseSix">
                                                    How do I add/change my profile picture?
                                                </button>
                                            </h5>
                                            <div id="membercollapseSix" class="accordion-collapse collapse"
                                                aria-labelledby="memberheadingSix" data-bs-parent="#memberaccordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="faq__two-left">
                                        <div class="accordion-item wow fadeInUp" data-wow-duration="600ms"
                                            data-wow-delay="600ms">
                                            <h5 class="accordion-header" id="memberheadingOne">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#membercollapseOne" aria-expanded="true"
                                                    aria-controls="membercollapseOne">
                                                    What is ChatGPT?
                                                </button>
                                            </h5>
                                            <div id="membercollapseOne" class="accordion-collapse collapse show"
                                                aria-labelledby="memberheadingOne" data-bs-parent="#memberaccordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item wow fadeInUp" data-wow-duration="600ms"
                                            data-wow-delay="900ms">
                                            <h5 class="accordion-header" id="memberheadingTwo">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#membercollapseTwo"
                                                    aria-expanded="false" aria-controls="membercollapseTwo">
                                                    How is Chatsonic different from ChatGPT by Open
                                                    AI?
                                                </button>
                                            </h5>
                                            <div id="membercollapseTwo" class="accordion-collapse collapse"
                                                aria-labelledby="memberheadingTwo" data-bs-parent="#memberaccordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="accordion-item content__space wow fadeInUp"
                                            data-wow-duration="600ms" data-wow-delay="1200ms">
                                            <h5 class="accordion-header" id="memberheadingThree">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#membercollapseThree"
                                                    aria-expanded="false" aria-controls="membercollapseThree">
                                                    What format are the files in?
                                                </button>
                                            </h5>
                                            <div id="membercollapseThree" class="accordion-collapse collapse"
                                                aria-labelledby="memberheadingThree" data-bs-parent="#memberaccordion">
                                                <div class="accordion-body">
                                                    <p>
                                                        analyses the speaker's face and gaze during a
                                                        video conversation to maintain eye contact
                                                        before changing the camera position.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "FAQ",
        mounted() {
            const faqTabContents = document.querySelectorAll('.faq-tab-content');
            const switchElement = document.getElementById('switch');
            const atcLabel = document.querySelector('.atc');
            const abcLabel = document.querySelector('.abc');

            // Show the first tab content
            faqTabContents[0].style.display = 'block';

            // Add change event listener to the switch
            switchElement.addEventListener('change', function () {
                // Hide all tab contents
                faqTabContents.forEach((content) => content.style.display = 'none');
                atcLabel.classList.remove('cd');
                abcLabel.classList.remove('cd');

                // Show the selected tab content with fade-in animation
                if (this.checked) {
                    document.getElementById('faqTwo').style.display = 'block';
                    atcLabel.classList.add('cd');
                } else {
                    document.getElementById('faqOne').style.display = 'block';
                    abcLabel.classList.add('cd');
                }
            });
        }
    }
</script>

<style scoped>
    .faq-tab-content {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/page_components/home-2/FAQ.vue